import SampleEventInputs from './SampleEventInputs'

export default SampleEventInputs
